import { CHANGE_MAP_SCALE, CHANGE_MAP_STATE, SET_MIN_MAX_SCALE } from './constants';
import { QUERY_STATE } from '../../constants';
import { TOGGLE_OPTIONAL_RENDER } from '../constants';
import { createReducer, baseReduceHandler } from '../reducer';
export const reducer = createReducer({
    mapState: QUERY_STATE.WAITING,
}, {
    [CHANGE_MAP_STATE]: (state, action) => ({ ...state, mapState: action.mapState }),
    [CHANGE_MAP_SCALE]: baseReduceHandler,
    [TOGGLE_OPTIONAL_RENDER]: baseReduceHandler,
    [SET_MIN_MAX_SCALE]: (state, action) => ({ ...state, minMaxScale: action.minMaxScale }),
});
//# sourceMappingURL=reducer.js.map